<template>
  <div class="card-management">
    <!-- <a-button type="primary" @click="visible = true" style="margin-bottom: 10px;"
      ><a-icon type="plus" />新增</a-button
    > -->
    <a-table
      :columns="columns"
      :data-source="dataSource"
      :row-key="(record) => record.id"
      :pagination="pagination"
      @change="tableChange"
    >
      <template slot="state" slot-scope="text">
        <a-tag :color="text == 1 ? 'green' : 'red'">
          {{ text == 1 ? '开启' : '关闭' }}
        </a-tag>
      </template>
      <template slot="operation" slot-scope="text, record">
        <a @click="exchangeCode(record)">管理兑换码</a>
        <a-divider type="vertical" />
        <a @click="handleDelete(record)">删除卡</a>
      </template>
    </a-table>
    <!-- <addMemberModal v-if="visible" :visible.sync="visible" @refresh="getMemberCardList" /> -->
  </div>
</template>

<script>
import addMemberModal from './modal/addMemberModal.vue'

const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: '会员卡名称',
    dataIndex: 'typeName',
    key: 'typeName',
  },
  {
    title: '定价',
    dataIndex: 'price',
    key: 'price',
  },
  {
    title: '权益',
    dataIndex: 'benefit',
    key: 'benefit',
  },
  {
    title: '开通人数',
    dataIndex: 'userNum',
    key: 'userNum',
  },
  {
    title: '状态',
    dataIndex: 'state',
    key: 'state',
    scopedSlots: { customRender: 'state' },
  },
  {
    title: '操作',
    key: 'operation',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
]
export default {
  name: 'cardManagement',
  data() {
    return {
      columns,
      dataSource: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      cardId: '',
      visible: false,
    }
  },
  components: {
    addMemberModal,
  },
  created() {
    this.getMemberCardList()
  },
  methods: {
    getMemberCardList() {
      this.$api.getMemberCardList().then((res) => {
        this.dataSource = res.data
      })
    },
    /* 表格变化（分页） */
    tableChange(pagination) {
      let { current, pageSize } = pagination
      this.pagination.current = current
      this.pagination.pageSize = pageSize
    },
    exchangeCode(record) {
      this.$router.push({
        path: '/layout/member/exchangeCodeManage',
        query: {
          id: record.id,
        },
      })
    },
    handleDelete(record) {
      this.$confirm({
        title: '确定删除该会员卡吗？',
        okText: '确定',
        cancelText: '取消',
        onOk: () => {
          this.$api.delMemberCard(record.id).then((res) => {
            if (res.code == 0) {
              this.$message.success('删除成功')
              this.getMemberCardList()
            }
          })
        },
      })
    },
  },
}
</script>

<style lang="less" scoped>
.card-management {
  padding: 20px 12px;
}
</style>